module.exports = "module.exports = __webpack_public_path__ + \"static/media/tableFooter.c87e9b06.template\";"